import React from 'react';
import './PointsAndMoney.css';
import {formatBigNumbers} from '../../../Helpers.js';

import medal from 'static/img/medal.svg';
import money from 'static/img/money.svg';

const PointsAndMoney = (props) =>{

  return (
    <div className="PointsAndMoney">

      <div className="PointsAndMoney-container PointsAndMoney-Points">
        <div className="PointsAndMoney-score">
          <span className="PointsAndMoney-value">{formatBigNumbers(Math.floor(props.pointsAndMoney.points))}</span>
          <span className="PointsAndMoney-unit">pts</span>
        </div>
        <div className="PointsAndMoney-description">collected from activities</div>
        <img className="PointsAndMoney-icon" src={medal} alt="" />
      </div>

      <div className="PointsAndMoney-container PointsAndMoney-Money">
        <div className="PointsAndMoney-score">
          <span className="PointsAndMoney-value">{formatBigNumbers(props.pointsAndMoney.money)}</span>
          <span className="PointsAndMoney-unit">pln</span>
        </div>
        <div className="PointsAndMoney-description">for a good cause</div>
        <img className="PointsAndMoney-icon" src={money} alt="" />
      </div>

    </div>
  )
}

export default PointsAndMoney;



// WEBPACK FOOTER //
// ./src/screens/bfmPanel/PointsAndMoney/PointsAndMoney.js